import { render, staticRenderFns } from "./FluxoProtesto.vue?vue&type=template&id=0cd80b6e"
import script from "./FluxoProtesto.vue?vue&type=script&lang=js"
export * from "./FluxoProtesto.vue?vue&type=script&lang=js"
import style0 from "./FluxoProtesto.vue?vue&type=style&index=0&id=0cd80b6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports